import { COLORS } from '@btime/constants'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../components/presentation/Text'
import { useCloseModal } from '../../../components/modals/ModalsContext'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const onClose = useCloseModal()

  return (
    <>
      <Grid justify="space-between">
        <Col flex={1}>
          <Title size="h5" strong color={COLORS.dark2} noMargin>
            Nova Automação
          </Title>
        </Col>
        <Col>
          <Icon name="BsX" onClick={onClose} size={1.5} color="dark3" />
        </Col>
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
